<template>
    <div class="supplier-search-wrapper">
		<div class="container mb-5">
			<div class="row">
				<div class="col-xl-3 col-lg-4 col-md-5">
					<div class="card card-filter">
						<div class="card-body">
							<div class="d-flex">
								<div class="card-filter-title">Lokasi</div>
								<div class="ml-auto">
									<button class="btn btn-sm btn-plain btn-collapse" data-toggle="collapse" :data-target="`#collapseLocation`" aria-expanded="false" :aria-controls="`collapseLocation`">
										<i class="bi-chevron-down"></i>
									</button>
								</div>
							</div>
							<div class="location-filter mt-3 ml-2 collapse show" id="collapseLocation">
								<div class="custom-control form-control-lg custom-checkbox" v-for="(location, index) in featuredLocations" :key="index">
									<input class="custom-control-input" type="checkbox" :value="location.value" :id="`location-${index}`" v-model="filterLocations" @change="applyFilter()">
									<label class="custom-control-label" :for="`location-${index}`">
										{{ location.name }}
									</label>
								</div>
								<!-- <div class="text-primary text-center cursor-pointer font-weight-bold mt-2" @click="showAllLocation">Lihat Semua</div> -->
								<div class="text-center">
									<button class="btn btn-plain text-primary font-weight-bold" data-toggle="modal" data-target="#locationModal">Lihat Semua</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xl-9 col-lg-8 col-md-7">
					<div class="row">
						<div class="col-md-12 mb-4">
							<div class="search-description align-self-center">
								<span :class="{ 'hidden': getParamsQuery('q') === '' }">Menampilkan hasil pencarian untuk <strong>"{{ getParamsQuery('q') }}".</strong></span>
							</div>
						</div>
						<template v-if="suppliers.length > 0 && !isLoading">
							<div v-for="(supplier, index) in suppliers" :key="`supplier-${index}`" class="col-xl-3 col-lg-4 col-md-6 col-6 d-flex justify-content-center">
								<supplier-card :supplier="supplier" @showDetail="showDetail(supplier)" />
							</div>
						</template>
						<template v-if="isLoading">
							<div v-for="(supplier, index) in dummySuppliers" :key="index" class="col-xl-3 col-lg-4 col-md-6 col-6 d-flex justify-content-center">
								<supplier-card :is-loading="isLoading" />
							</div>
						</template>
						<template v-if="!isLoading">
							<div class="col-12" v-if="suppliers.length < 1">
								<div class="card card-body card-supplier-empty border-0 d-flex">
									<div class="empty-description">
										Oops, supplier tidak ditemukan.
									</div>
								</div>
							</div>
							<div class="col-12 d-flex justify-content-center" v-if="isLoadMoreEnabled && page < totalPages && !isLoading">
								<button type="button" class="btn-outline o-lg outline-primary" @click="loadMore">Muat Lebih Banyak</button>
							</div>
						</template>
					</div>
					<!-- <div class="d-flex">
						<pagination
							class="ml-auto"
							v-if="this.totalPages > 1"
							:total-pages="totalPages"
							:total="totalItems"
							:per-page="limit"
							:current-page="page"
							:max-visible-buttons="maxVisibleButtons"
							@pagechanged="onPageChange"
						/>
						<div v-else></div>
					</div> -->
				</div>
			</div>

			<div class="modal" tabindex="-1" id="locationModal">
				<div class="modal-dialog modal-lg">
					<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Semua Lokasi</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<i class="bi bi-x-lg"></i>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<input type="email" class="form-control" id="search-location" placeholder="Cari nama Kota/Kabupaten" v-model="searchLocation">
						</div>
						<div class="location-conatiner">
							<div class="row" v-for="(province, index) in locations" :key="index">
								<div class="col-12 mb-2" :class="{ 'mt-3': index !== 0 }">
									<strong>{{ province._id }}</strong>
								</div>
								<template v-for="(city, i) in province.cities">
									<div class="col-4 mb-1"
										:key="i"
										v-if="city.city_name_with_type.toLowerCase().indexOf(searchLocation.toLowerCase()) !== -1"
									>
										<div class="custom-control form-control-md custom-checkbox">
											<input class="custom-control-input" type="checkbox" :value="city.city_id" :id="`location-all-${index}-${i}`" v-model="filterLocations">
											<label class="custom-control-label" :for="`location-all-${index}-${i}`">
												{{ city.city_name_with_type }}
											</label>
										</div>
									</div>
								</template>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn-outline outline-warning o-sm" @click="filterLocations = []; searchLocation=''">Reset</button>
						<button type="button" class="btn-outline outline-primary o-sm" @click="applyFilter" data-dismiss="modal">Terapkan</button>
					</div>
					</div>
				</div>
			</div>
		</div>

		<main-footer />
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import SupplierCard from '@/components/SupplierCard.vue';
import MainFooter from '@/components/homepages/Footer.vue';
// import Pagination from '@/components/homepages/Pagination.vue';
import shippingApi from '@/api/shipping';
import homepageApi from '@/api/homepage';
import {
	getAxiosErrorMessage,
} from '@/lib/helper';

import {
	homepageFeaturedLocations,
	paginationMaxVisibleButtons,
} from '@/lib/statics';

export default {
	name: 'HomepageSupplier',
	components: {
		SupplierCard,
		MainFooter,
		// Pagination,
	},
	props: {
	},
	data() {
		return {
			page: 1,
			limit: 12,
			dummySuppliers: new Array(4),
			featuredLocations: homepageFeaturedLocations,
			filterLocations: [],
			isLoading: true,
			locations: [],
			isLocationSearching: false,
			suppliers: [],
			searchLocation: '',
			totalPages: 0,
			totalItems: 0,
			maxVisibleButtons: paginationMaxVisibleButtons,
			isLoadMoreEnabled: true,
		};
	},
	methods: {
		showDetail(supplier) {
			const encodedUserId = btoa(supplier.user._id.$oid);
			this.$router.push({ name: 'supplier-detail', params: { slug: `${supplier.slug}-${encodedUserId}` } });
		},
		getParamsQuery(param) {
			const result = this.$route.query[param];
			return result || '';
		},
		fetchCompleteCities() {
			this.locations = [];

			this.isLocationSearching = true;
			const params = {
				get_complete_data: 1,
				page: 1,
			};
			const callback = (response) => {
				const locations = response.data;
				this.locations = locations;
				this.isLocationSearching = false;
			};
			const errorCallback = (e) => {
				this.isLocationSearching = false;
				const message = getAxiosErrorMessage(e);
				console.log('message: ', message);
			};
			shippingApi.getCompleteCitiesGrouped(params, callback, errorCallback);
		},
		fetchParams() {
			const params = {
				limit: this.limit,
				page: this.page,
				use_cache_header: true,
			};

			const sessionId = sessionStorage.getItem('sessionId');
			if (sessionId) {
				params.session_id = sessionId;
			}

			const locations = this.filterLocations;
			if (locations.length > 0) {
				params.locations = JSON.stringify(locations);
			}

			return params;
		},
		fetchSuppliersPublic(reset = true) {
			this.isLoading = true;
			this.isLoadMoreEnabled = true;

			const params = this.fetchParams();

			const callback = (response) => {
				const suppliers = response.data.suppliers;
				if (!reset) {
					this.suppliers = [...this.suppliers, ...suppliers];
				} else {
					this.suppliers = suppliers;
				}

				this.totalPages = response.data.page_info.last_page;
				this.totalItems = response.data.page_info.total_all_suppliers;

				if (this.totalPages <= 1) { // total pages decrease as the suppliers pushed into array, total pages 1 means the last page
					this.isLoadMoreEnabled = false;
				}

				// set pagination max visible button
				this.maxVisibleButtons = this.totalPages;
				if (this.totalPages > paginationMaxVisibleButtons) {
					this.maxVisibleButtons = paginationMaxVisibleButtons;
				}

				this.isLoading = false;
			};

			const errorCallback = () => {
				this.suppliers = [];
				this.resetPagination();
				this.isLoading = false;
			};

			homepageApi.getPublicSuppliers(params, callback, errorCallback);
		},
		resetPagination() {
			this.page = 1;
			this.totalPages = 0;
			this.totalItems = 0;
			this.maxVisibleButtons = paginationMaxVisibleButtons;
		},
		applyFilter() {
			this.resetPagination();
			const queryChanged = this.updateLocationsQuery();
			if (!queryChanged) {
				this.fetchSuppliers();
			}
		},
		parseLocationsQuery(value) {
			if (!value) {
				return [];
			}

			const normalize = (item) => {
				const numeric = Number(item);
				return Number.isNaN(numeric) ? item : numeric;
			};

			if (Array.isArray(value)) {
				return value.map(normalize);
			}

			if (typeof value === 'string') {
				try {
					const parsed = JSON.parse(value);
					if (Array.isArray(parsed)) {
						return parsed.map(normalize);
					}
				} catch (error) {
					const splitted = value.split(',').map(item => item.trim()).filter(Boolean);
					return splitted.map(normalize);
				}
			}

			return [];
		},
		syncFiltersFromRoute() {
			const parsedLocations = this.parseLocationsQuery(this.getParamsQuery('locations'));
			const current = JSON.stringify(this.filterLocations);
			const incoming = JSON.stringify(parsedLocations);
			if (current !== incoming) {
				this.filterLocations = parsedLocations;
			}
		},
		updateLocationsQuery() {
			const currentQuery = { ...this.$route.query };
			const hasLocations = this.filterLocations.length > 0;
			const encodedLocations = hasLocations ? JSON.stringify(this.filterLocations) : undefined;
			const currentEncoded = currentQuery.locations;

			if (hasLocations) {
				if (currentEncoded === encodedLocations) {
					return false;
				}
				currentQuery.locations = encodedLocations;
			} else if (currentEncoded !== undefined) {
				delete currentQuery.locations;
			} else {
				return false;
			}

			this.$router.replace({ query: currentQuery }).catch(() => {});
			return true;
		},
		fetchSuppliers(reset = true) {
			this.fetchSuppliersPublic(reset);
		},
		onPageChange(page) {
			this.page = page;
			this.fetchSuppliers();
		},
		checkQuery() {
			this.syncFiltersFromRoute();
			this.fetchSuppliers();
		},
		generateSessionId() {
			const sessionId = this.$uuid.v4();
			sessionStorage.setItem('sessionId', sessionId);
		},
		loadMore() {
			this.dummySuppliers = new Array(this.suppliers.length);
			this.page++;
			this.fetchSuppliers(false);
		},
	},
	computed: {
		...mapGetters({
			searchQuery: 'homepage/searchQuery',
			searchType: 'homepage/searchType',
			user: 'user',
		}),
	},
	created() {
		this.generateSessionId();
		this.checkQuery();
		this.fetchCompleteCities();
	},
	watch: {
		'$route.query': {
			handler() {
				this.resetPagination();
				this.checkQuery();
			},
		},
		user() {
			this.fetchSuppliers();
		},
	},
};
</script>
<style lang="scss" scoped>
	@import '../assets/scss/modules/_variables.scss';

	.supplier-search-wrapper {
		margin-top: 40px;
	}

	.card-filter {
		border: none;
		border-radius: 16px;

		.card-filter-title {
			font-style: normal;
			font-weight: 600;
			font-size: 20px;
		}

		.custom-control-label {
			color: #4d4d4d99;
			font-style: normal;
			font-weight: 500;
			font-size: 16px;
		}
	}

	.btn-collapse {
		&.collapsed {
			.bi-chevron-down {
				transform: rotateX(0);
				transition-duration: 0.5s;
			}
		}
	}

	.btn-collapse {
		&:not(.collapsed) {
			.bi-chevron-down {
				transform: rotateX(-180deg);
				transition-duration: 0.5s;
			}
		}
	}

	.custom-checkbox .custom-control-input:checked~.custom-control-label::before{
		background-color: $color__primary;
	}

	.card-supplier-empty {
		border-radius: 16px;
		padding: 30px;
	}

	.modal {
		.modal-dialog{
			overflow-y: initial !important
		}
		.modal-body{
			height: 290px;
			overflow-y: auto;
		}
		.modal-header{
			background-color: transparent;
		}
		.modal-content{
			border-radius: 16px;
		}
		.modal-footer {
			border-top: none;
			background-color: transparent;
		}
	}

</style>
